<div class="curtain">
    <section class="component-modalDialog editDocxDialog redesigned size-6">

        <header>
            Souhlas s dočasným předáním dokumentu
            <a class="closeModalDialog fa fa-close" (click)="closeModal(false)"></a>
        </header>

        <div class="contentContainer scrollable nativeScrollbar inside">
            <div class="col-full no-height">
                <p class="message"><strong>Abychom zajistili službu online editace smluvního dokumentu, je nutné předat tento dokument třetí straně společnosti Microsoft.</strong></p>
            </div>

            <div class="col-full no-height flex flex-center">
                <form>
                    <input
                        type="checkbox"
                        name="onlineEditTermsAgreement"
                        value="docxPopupEnabled"
                        id="onlineEditTermsAgreement"
                        (click)="toggleOnlineEditTermsAgreement();"
                        [checked]="onlineEditTermsAgreement">
                    <label
                        for="onlineEditTermsAgreement"
                        class="showAsCheckbox withLabel"
                        title="Souhlasit">
                        Beru na vědomí, že moje současné i budoucí dokumenty mohou být dočasně předány k zajištění služby online editace.
                    </label>
                </form>
            </div>
        </div>

        <footer>
            <a class="button-primary"
               [ngClass]="{'disabled': !onlineEditTermsAgreement}"
               (click)="passAgreement()"
               >Souhlasit</a>
            <a class="button-secondary" (click)="closeModal(null)">Zrušit</a>
        </footer>
    </section>
</div>